import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ReactNotifications } from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'
import { selectIsAuth, selectAppIsInitialized } from '@src/store/ducks/app/selectors'
import { PageContainer } from '@src/components/PageContainer/PageContainer'
import { AppDispatch } from '@src/store/store'
import { fetchMe } from '@src/store/ducks/app/thunks'
import { Preloader } from '@src/components/common/Preloader/Preloader'
import { RoutesProject } from './routes/routes'

export const App = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isAuth = useSelector(selectIsAuth)
  const isInitialized = useSelector(selectAppIsInitialized)

  useEffect(() => {
    dispatch(fetchMe())
  }, [dispatch])

  if (!isInitialized) {
    return <Preloader loading={!isInitialized} center />
  }
  return (
    <div className="App">
      <ReactNotifications />
      {isAuth ? (
        <PageContainer>
          <RoutesProject />
        </PageContainer>
      ) : (
        <RoutesProject />
      )}
    </div>
  )
}
